import { Button, InputGroup, Menu, MenuItem, Popover } from '@blueprintjs/core'
import React, { useCallback, useRef, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { walk } from 'react-sortable-tree'
import { OverlayProps } from '../../helper/configs'
import { globalOnDemandVars } from '../../helper/context'
import { getParsedText, openNewWindowAtWindow2ByPath, truncateDefault } from '../../helper/functions'
import { getNodeKey } from '../list/window1/functions'
import v from 'voca'

export const nodeDataToLeftIcon = (nodeData) => {
  const parentNode = nodeData.parentNode
  const isRootNode = nodeData.node.id === 'rootNode'

  return (
    isRootNode ? null : (
      <span css={css`color: var(--gray8);`} title={!parentNode ? globalOnDemandVars.topRootName() : parentNode.title}>{(!parentNode ? truncateDefault(globalOnDemandVars.topRootName(), true) : truncateDefault(parentNode.title, true)) + ' >'}</span>
    ))
}

function SearchBar ({ openAtNewWindow, setPath, large, fill }) {
  const [value, setValue] = useState('')

  const [popoverDisabled, setPopoverDisabled] = useState(true)
  const linkedNodes = useRef([])
  const onMouseDown = useCallback(
    (e) => {
      if (value) {
        e.preventDefault()

        const parsedValue = getParsedText(value)

        const treeData = globalOnDemandVars.isPixelMode() ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()

        const exactlyMatched = []
        const partlyMatched = []
        walk({
          treeData,
          getNodeKey,
          ignoreCollapsed: false,
          callback: ({ node, path, parentNode }) => {
            const parsedNodeTitle = getParsedText(node.title)
            if (v.includes(parsedNodeTitle, parsedValue)) {
              const nodeInfo = { node, path, parentNode }
              if (parsedNodeTitle === parsedValue) {
                exactlyMatched.push(nodeInfo)
                // eslint-disable-next-line no-useless-escape
              } else if (v.matches(parsedNodeTitle, ('[^\\[]' + parsedValue + '[^\\]]' + '|^' + parsedValue + '|' + parsedValue + '$'))) {
                partlyMatched.push(nodeInfo)
              }
            }
          }
        })

        if (exactlyMatched.length) {
          linkedNodes.current = exactlyMatched
          if (linkedNodes.current.length === 1) {
            const matchedNodeInfo = linkedNodes.current[0]
            setPopoverDisabled(true)
            if (openAtNewWindow) {
              openNewWindowAtWindow2ByPath(matchedNodeInfo.path)
            } else {
              setPath({ path: matchedNodeInfo.path })
            }
          } else {
            setPopoverDisabled(false)
          }
        } else {
          linkedNodes.current = partlyMatched
          if (linkedNodes.current.length === 1) {
            const matchedNodeInfo = linkedNodes.current[0]
            setPopoverDisabled(true)
            if (openAtNewWindow) {
              openNewWindowAtWindow2ByPath(matchedNodeInfo.path)
            } else {
              setPath({ path: matchedNodeInfo.path })
            }
          } else {
            setPopoverDisabled(false)
          }
        }

        setValue('')
      }
    },
    [openAtNewWindow, setPath, value]
  )

  return (
    <Popover {...OverlayProps} minimal position={'bottom-left'} targetTagName={'div'} isOpen={!popoverDisabled} onClose={() => { setPopoverDisabled(true) }} interactionKind={'click'} content={(
      <Menu css={css`max-height: 400px; overflow: auto;`}>{
        linkedNodes.current.length ? linkedNodes.current.map((nodeInfo) => (
          <MenuItem
            key={nodeInfo.node.id}
            // label={nodeData.key}
            onClick={() => {
              if (openAtNewWindow) {
                openNewWindowAtWindow2ByPath(nodeInfo.path)
              } else {
                setPath({ path: nodeInfo.path })
              }
              setPopoverDisabled(true)
            }}
            title={nodeInfo.node.title}
            text={truncateDefault(nodeInfo.node.title)}
            icon={nodeDataToLeftIcon(nodeInfo)}
            shouldDismissPopover
          />
        )) : <span css={css`color: var(--gray6);`}>Nothing Found</span>
      }</Menu>
    )}>
      <InputGroup value={value} onChange={(e) => {
        setValue(e.target.value)
        setPopoverDisabled(true)
      }} round fill={fill} large={large} rightElement={(
        <Button icon={'search'} minimal onClick={onMouseDown} />
      )} onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onMouseDown(e)
        }
      }} />
    </Popover>
  )
}

export default SearchBar
